module.exports = __webpack_public_path__ + "static/media/calHome.2df4717f.svg";